export function buttonConfig() {
    return {
        textTransform: "none"
    };
}
